module.exports = __webpack_public_path__ + "img/ico_light_1.8fe8efc1.png";